"use strict";
exports.__esModule = true;
exports.prettyInstalled = exports.prettyActionPlan = exports.formatSize = void 0;
var formatSize = function (size, blockSize) {
    if (size === void 0) { size = 0; }
    var formatedSize = size && Math.ceil((Math.ceil(size / blockSize) * blockSize) / 1024);
    return formatedSize ? "".concat(formatedSize, "Kb") : "";
};
exports.formatSize = formatSize;
var prettyActionPlan = function (ops) {
    return ops.map(function (op) { return (op.type === "install" ? "+" : "-") + op.name; }).join(", ");
};
exports.prettyActionPlan = prettyActionPlan;
var prettyInstalled = function (items) {
    return items
        .map(function (_a) {
        var name = _a.name, updated = _a.updated;
        return name + (updated ? "" : " (outdated)");
    })
        .join(", ");
};
exports.prettyInstalled = prettyInstalled;
//# sourceMappingURL=formatting.js.map